module.exports = __webpack_public_path__ + "media/application/images/svgs/battery-dcd0d938e9243fd37d97495d52e5320a.svg";